__turbopack_context__.v({
  "container": "Footer-module__Ln6G0W__container",
  "cookiePreferences": "Footer-module__Ln6G0W__cookiePreferences",
  "copyright": "Footer-module__Ln6G0W__copyright",
  "footnote": "Footer-module__Ln6G0W__footnote",
  "footnoteContent": "Footer-module__Ln6G0W__footnoteContent",
  "listTitle": "Footer-module__Ln6G0W__listTitle",
  "logo": "Footer-module__Ln6G0W__logo",
  "logos": "Footer-module__Ln6G0W__logos",
  "newsletterHeader": "Footer-module__Ln6G0W__newsletterHeader",
  "pageLinks": "Footer-module__Ln6G0W__pageLinks",
  "sidebar": "Footer-module__Ln6G0W__sidebar",
  "topLevelGrid": "Footer-module__Ln6G0W__topLevelGrid",
});
